
export const isValidNumber = (value: any): boolean => {
  const num = Number(value);
  return typeof num === "number" && Number.isFinite(num);
};

export const isValidCoordinates = (lat: any, lng: any): boolean => {
  if (!isValidNumber(lat) || !isValidNumber(lng)) return false;
  const latNum = Number(lat);
  const lngNum = Number(lng);
  return latNum >= -90 && latNum <= 90 && lngNum >= -180 && lngNum <= 180;
};
